// app_client/src/utils/formatters.js
/**
 * Finansal ve Genel Formatlama Yardımcıları
 */

/**
 * Para birimini yerel formatta (tr-TR) biçimlendirir.
 * @param {number|string} value - Formatlanacak sayısal değer
 * @param {string} currency - Para birimi kodu (TRY, USD, EUR vb.)
 * @returns {string} - Formatlanmış para birimi stringi
 */
export const formatCurrency = (value, currency = 'TRY') => {
  const amount = Number(value) || 0;
  
  try {
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  } catch {
    // Para birimi kodu hatalıysa veya desteklenmiyorsa güvenli dönüş
    return amount.toFixed(2) + ' ' + currency;
  }
};

/**
 * Sayıları binlik ayraçlı formatta gösterir (Para simgesi olmadan)
 * @param {number|string} value 
 * @returns {string} - Örn: 1.250,50
 */
export const formatNumber = (value) => {
  const num = Number(value) || 0;
  return new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(num);
};

/**
 * ISO Tarih formatını (2026-05-05) kullanıcı dostu formata çevirir.
 * @param {string} dateString 
 * @returns {string} - Örn: 5 Mayıs 2026
 */
export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('tr-TR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  }).format(date);
};

/**
 * Oran/Yüzde formatlama
 * @param {number} value - Örn: 20
 * @returns {string} - Örn: %20
 */
export const formatPercent = (value) => {
  const num = Number(value) || 0;
  return `%${num}`;
};